<template>
    <div>
        <Modal v-model="modalShow" :title="$t('Approves')" width="88%"><!-- 审批 -->
            <Tabs type="card" value="1" :animated="false" name="modalTabs">
                <TabPane :label="$t('Pending_Approvals')" name="1" tab="modalTabs"><ApprovalList></ApprovalList></TabPane><!-- 审批一览 -->
                <TabPane :label="$t('Agency_Approval_List')" name="2" tab="modalTabs"><AgencyApprovalList></AgencyApprovalList></TabPane><!-- 代理审批一览 -->
                <TabPane :label="$t('Approval_History')" name="3" tab="modalTabs"><ApprovalHistory></ApprovalHistory></TabPane><!-- 审批历史 -->
            </Tabs>
        </Modal>
    </div>
</template>

<script>
import axios from 'axios'
import ApprovalList from './ApprovalList.vue'
import AgencyApprovalList from './AgencyApprovalList.vue'
import ApprovalHistory from './ApprovalHistory.vue'
export default {
    components:{AgencyApprovalList,ApprovalHistory,ApprovalList},
    data(){
        return{
            modalShow:false,
        }
    },
    created(){
    },
    methods:{
        
    }
}
</script>


// WEBPACK FOOTER //
// src/components/process/performanceManagement/components/modalComponents/BatchApprovalModalComponent.vue